import { configureStore } from '@reduxjs/toolkit';

import { api } from '@/services/api';
import authReducer from '@/services/auth';
import { shopsReducer } from '@/features/shops';
import { ordersReducer } from '@/features/orders';
import { userReducer } from '@/features/users';

export const store = configureStore({
  reducer: {
    [api.reducerPath]: api.reducer,
    shops: shopsReducer,
    user: userReducer,
    auth: authReducer,
    orders: ordersReducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(api.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export { useAppDispatch, useAppSelector } from './hooks';
